import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";   // <-- add this
import "react-toastify/dist/ReactToastify.css";

export default function AdminLogin({ closeModal }) {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // <-- new
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://mediapi.onlinepharmaque.in/api/v1/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identifier, password }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("adminIdentifier", identifier);
        localStorage.setItem("token", data.token);

        toast.success("✅ Login Successful!", {
          position: "top-right",
          autoClose: 2000,
          onClose: () => {
            navigate("/");
            if (closeModal) closeModal();
          }
        });

      } else {
        toast.error(data.message || "❌ Invalid Identifier or Password", {
          position: "top-right",
          autoClose: 3000,
        });
      }

    } catch (err) {
      console.error(err);
      toast.error("❌ Server Error. Try again later.", {
        position: "top-right",
        autoClose: 3000,
      });

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0b1220] via-[#0f172a] to-[#020617] relative">
      <ToastContainer />

      <div className="w-full max-w-md bg-[#0f172a] border border-slate-700 rounded-2xl shadow-2xl p-8 text-white">
        <h2 className="text-2xl font-bold text-center">Admin Login</h2>
        <p className="text-center text-sm text-slate-400 mb-6">Login to Admin Dashboard</p>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-sm text-slate-300 mb-1">Email or Username</label>
            <input
              type="text"
              placeholder="rahul.sharma@example.com"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="w-full px-4 py-2 bg-[#020617] border border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div className="relative">
            <label className="block text-sm text-slate-300 mb-1">Password</label>
            <input
              type={showPassword ? "text" : "password"}   // <-- change
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 bg-[#020617] border border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />

            <span
              className="absolute right-3 top-9 cursor-pointer text-slate-400"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-blue-600 hover:bg-blue-700 py-2 rounded-lg font-semibold transition ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}